import { FC } from 'react';

import { toast } from 'sonner';
import useSWRMutation from 'swr/mutation';

import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';

import { userService } from 'v2/api/userService';
import { UserModel } from 'v2/types/UserModel';
import { handleHttpError } from 'v2/utils';

interface DeleteUserDialogProps {
  user: UserModel;
  isOpen: boolean;
  onClose: VoidFunction;
  onRevalidate: VoidFunction;
}

export const DeleteUserDialog: FC<DeleteUserDialogProps> = ({ user, isOpen, onClose, onRevalidate }) => {
  const { trigger, isMutating } = useSWRMutation(['deleteUser', user.id], userService.deleteUser, {
    onSuccess: (user) => {
      onRevalidate();
      toast.info(`The user ${user.userNickname} has been deleted`);
    },
    onError: handleHttpError,
  });

  const handleDelete = () => {
    trigger();
  };

  return (
    <Dialog open={isOpen} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>Delete User</DialogTitle>

      <DialogContent>Are you sure that you want to delete this user?</DialogContent>

      <DialogActions>
        <Button onClick={onClose} variant="contained">
          Cancel
        </Button>

        <Button onClick={handleDelete} type="submit" variant="contained" color="error" loading={isMutating}>
          Delete
        </Button>
      </DialogActions>
    </Dialog>
  );
};
